import { render, staticRenderFns } from "./BlockedVisitors.vue?vue&type=template&id=2cff39e2&scoped=true"
import script from "./BlockedVisitors.vue?vue&type=script&lang=js"
export * from "./BlockedVisitors.vue?vue&type=script&lang=js"
import style0 from "./BlockedVisitors.vue?vue&type=style&index=0&id=2cff39e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff39e2",
  null
  
)

export default component.exports